/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-20 14:39:10
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-09-08 13:29:27
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import install from "./config/install";
import ViewUI from "view-design";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import "view-design/dist/styles/iview.css";
import "../my-theme/index.less";
import "./style/base.less";
import "./assets/iconfont/iconfont.css";
import "./config/other";
import "./common/filters";
import Component from "vue-class-component";
Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate",
]);
import i18n from "./config/i18n";
Vue.config.productionTip = false;
Vue.use(ViewUI, {
    i18n: function (path, options) {
        const value = i18n.t(path, options);
        if (value !== null && value !== undefined)
            return value;
        return "";
    },
});
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999,
    },
});
Vue.use(install);
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
